export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const VERIFY_TOKEN = "VERIFY_TOKEN";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_EMAIL = "RESET_EMAIL";
export const RESET_CODE = "RESET_CODE";
export const FETCH_ADMIN_STATS = "FETCH_ADMIN_STATS";
export const APPROVED_SUPPLIERS = "APPROVED_SUPPLIERS";
export const UNAPPROVED_SUPPLIERS = "UNAPPROVED_SUPPLIERS";
export const APPROVED_CUSTOMERS = "APPROVED_CUSTOMERS";
export const UNAPPROVED_CUSTOMERS = "UNAPPROVED_CUSTOMERS";
export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const BASE_CURRENCY = "BASE_CURRENCY";
export const FETCH_CURRENCIES = "FETCH_CURRENCIES";
export const FETCH_COUNTRIES = "FETCH_COUNTRIES";
export const ADD_CURRENCY = "ADD_CURRENCY";
export const FETCH_CATEGORIES = "FETCH_CATEGORIES";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const FETCH_APPROVED_SUPPLIER = "FETCH_APPROVED_SUPPLIER";
export const FETCH_UNAPPROVED_SUPPLIER = "FETCH_UNAPPROVED_SUPPLIER";
export const FETCH_SETTINGS = "FETCH_SETTINGS";
export const DELETE_APPROVED_SUPPLIER = "DELETE_APPROVED_SUPPLIER";
export const GET_CUSTOMER = "GET_CUSTOMER";
export const GET_UNAPPROVED_CUSTOMER = "GET_UNAPPROVED_CUSTOMER";
export const DELETE_APPROVED_CUSTOMER = "DELETE_APPROVED_CUSTOMER";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const PAUSE_SUPPLIER_SIGNUP = "PAUSE_SUPPLIER_SIGNUP";
export const RESUME_SUPPLIER_SIGNUP = "RESUME_SUPPLIER_SIGNUP";
export const PAUSE_USER_SIGNUP = "PAUSE_USER_SIGNUP";
export const RESUME_USER_SIGNUP = "RESUME_USER_SIGNUP";
export const LOGOUT = "LOGOUT";
export const ADD_SUPPLIER = "ADD_SUPPLIER";
export const ADD_CUSTOMER = "ADD_CUSTOMER";
export const TOKEN = "TOKEN";
export const UPDATE_SUPPLIER = "UPDATE_SUPPLIER";
export const UPDATE_UNAPPROVED_SUPPLIER = " UPDATE_UNAPPROVED_SUPPLIER";
export const UPDATE_UNAPPROVED_SUPPLIER_LICENCE =
  "UPDATE_UNAPPROVED_SUPPLIER_LICENCE";
export const UPDATE_SUPPLIER_LICENCE = "UPDATE_SUPPLIER_LICENCE";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const UPDATE_ADMIN_USERNAME = "UPDATE_ADMIN_USERNAME";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const UPDATE_UNAPPROVED_CUSTOMER = "UPDATE_UNAPPROVED_CUSTOMER";
export const UPDATE_CUSTOMER_LICENCE = "UPDATE_CUSTOMER_LICENCE";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const DELETE_UNAPPROVED_SUPPLIER = "DELETE_UNAPPROVED_SUPPLIER";
export const RESTORE_SUPPLIER_ACCOUNT = "RESTORE_SUPPLIER_ACCOUNT";
export const RESTORE_USER_ACCOUNT = "RESTORE_USER_ACCOUNT";
export const DELETE_UNAPPROVED_CUSTOMER = "DELETE_UNAPPROVED_CUSTOMER";
export const DELETED_SUPPLIERS = "DELETED_SUPPLIERS";
export const DELETED_USERS = "DELETED_USERS";
export const UPDATE_BANK_DETAILS = "UPDATE_BANK_DETAILS";
export const FETCH_ORDERS = "FETCH_ORDERS";
export const FETCH_ORDERS_BY_SUPPLIER = "FETCH_ORDERS_BY_SUPPLIER";
export const FETCH_SUPPLIER_PAYMENTS = "FETCH_SUPPLIER_PAYMENTS";
export const UPDATE_SUPPLIER_PAYMENTS = "UPDATE_SUPPLIER_PAYMENTS";
export const FETCH_SUPPLIER_PRODUCTS = "FETCH_SUPPLIER_PRODUCTS";
export const FETCH_SUPPLIER_REPORTS = "FETCH_SUPPLIER_REPORTS";
export const FETCH_ORDER = "FETCH_ORDER";
export const FETCH_TRANSACTIONS = "FETCH_TRANSACTIONS";
export const FETCH_SELECTED_SUPPLIERS = "FETCH_SELECTED_SUPPLIERS";
export const RESUME_SUPPLIER_CALL_REQUEST = "RESUME_SUPPLIER_CALL_REQUEST";
export const PAUSE_SUPPLIER_CALL_REQUEST = "PAUSE_SUPPLIER_CALL_REQUEST";
export const RESUME_CUSTOMER_CALL_REQUEST = "RESUME_CUSTOMER_CALL_REQUEST";
export const PAUSE_CUSTOMER_CALL_REQUEST = "PAUSE_CUSTOMER_CALL_REQUEST";
export const CALL_USER_REQUESTS = "CALL_USER_REQUESTS";
export const CALL_SUPPLIER_REQUESTS = "CALL_SUPPLIER_REQUESTS";
export const FETCH_SUPPLIER_FAQ = "FETCH_SUPPLIER_FAQ";
export const FETCH_CUSTOMER_FAQ = "FETCH_CUSTOMER_FAQ";
export const CREATE_SUPPLIER_FAQ = "CREATE_SUPPLIER_FAQ";
export const CREATE_USER_FAQ = "CREATE_USER_FAQ";
export const UPDATE_SUPPLIER_FAQ = "UPDATE_SUPPLIER_FAQ";
export const UPDATE_USER_FAQ = "UPDATE_USER_FAQ";
export const DELETE_SUPPLIER_FAQ = "DELETE_SUPPLIER_FAQ";
export const DELETE_USER_FAQ = "DELETE_USER_FAQ";
export const DELETE_CALL_SUPPLIER_REQUEST = "DELETE_CALL_SUPPLIER_REQUEST";
export const DELETE_CALL_USER_REQUEST = "DELETE_CALL_USER_REQUEST";
export const UPDATE_MULTIPLE_APPROVED_SUPPLIERS =
  "UPDATE_MULTIPLE_APPROVED_SUPPLIERS";
export const UPDATE_MULTIPLE_UNAPPROVED_SUPPLIERS =
  "UPDATE_MULTIPLE_UNAPPROVED_SUPPLIERS";
export const UPDATE_MULTIPLE_CUSTOMERS = "UPDATE_MULTIPLE_CUSTOMERS";
export const UPDATE_MULTIPLE_UNAPPROVED_CUSTOMERS =
  "UPDATE_MULTIPLE_UNAPPROVED_CUSTOMERS";
export const REFUND = "DELETE_USER_FAQ";
